import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import Button from '../ui-kit/Button';
import useAuthStore from '../../stores/authStore';
import { useNavigate } from 'react-router-dom';

function AuthBlock() {
  const [showPassword, setShowPassword] = useState(false);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const { login: loginAction, loading, error } = useAuthStore();
  const navigate = useNavigate();

  const toggleVisibility = () => {
    setShowPassword(prev => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ok = await loginAction({ login, password });
    if (ok) navigate('/home');
  };

  return (
    <div className='AuthBlock'>
      <div className="title">
        Авторизация
      </div>
      <form onSubmit={handleSubmit}>
        <div className="inputBlock">
          <input placeholder='Логин' value={login} onChange={e => setLogin(e.target.value)} autoFocus />
        </div>
        <div className="inputBlock passwordBlock">
          <input
            placeholder='Пароль'
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <span className="toggleIcon" onClick={toggleVisibility}>
            {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
          </span>
        </div>
        {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
        <Button text={loading ? 'Вход...' : 'Войти'} onClick={handleSubmit} />
      </form>
    </div>
  );
}

export default AuthBlock;
